import { defineSlotRecipe } from '@chakra-ui/react';
import { tableAnatomy } from '@chakra-ui/react/anatomy';

export const tableRecipe = defineSlotRecipe({
    // Full stock anatomy, per the Chakra guide for overriding built-in
    // recipes. Never re-declare a hand-picked subset here: createSystem
    // deep-merges arrays element-wise, so ['root', 'columnHeader', 'body']
    // positionally renamed stock slot 1 'header' to 'columnHeader',
    // silently dropping Table.Header's stock styles (e.g. the outline
    // variant's thead bg, stickyHeader).
    slots: tableAnatomy.keys(),
    base: {
        root: { fontFamily: 'table' },
        columnHeader: {
            // bg.subtle, matching cloud-ui's table headers. Text rests
            // muted and is inherited (labels/arrows must not pin their own
            // color) so the sortable hover below can strengthen the whole
            // cell.
            bg: '{colors.bg.subtle}',
            color: '{colors.fg.muted}',
            '& [data-sortable="true"]': {
                cursor: 'pointer',
                // bg.hover's ~5% tint is invisible on the header — hover
                // steps to the theme's next surface, and the label steps to
                // full-strength fg for contrast.
                _hover: {
                    bg: '{colors.bg.muted}',
                    color: '{colors.fg}',
                },
                // The sort control is a bare chakra <button> (table.tsx),
                // not a recipe component — without this it falls back to
                // the UA blue focus ring. Author outline replaces the UA
                // one inside the same :focus-visible state; inset so it
                // stays inside the cell instead of clipping under the
                // ScrollArea border.
                _focusVisible: {
                    outlineWidth: '2px',
                    outlineStyle: 'solid',
                    outlineColor: 'colorPalette.focusRing',
                    outlineOffset: '-2px',
                },
            },
        },
        body: { fontFamily: 'tableBody', fontSize: 'md' },
    },
});
